import { render, staticRenderFns } from "./DriverShipping.vue?vue&type=template&id=234849f8&scoped=true&"
import script from "./DriverShipping.vue?vue&type=script&lang=js&"
export * from "./DriverShipping.vue?vue&type=script&lang=js&"
import style0 from "./DriverShipping.vue?vue&type=style&index=0&id=234849f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234849f8",
  null
  
)

component.options.__file = "DriverShipping.vue"
export default component.exports